export enum MessageScope {
  SESSION = 1,
  PAGE = 0
}
